;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.directives')
    .directive('clientSelector', ClientSelectorDirective)

  ClientSelectorDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function ClientSelectorDirective (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {

    return {
      restrict: 'E',
      require: {
        ngModelCtrl: 'ngModel'
      },
      bindToController: {
        ngModel: '='
      },
      scope: true,
      controller: ClientSelectorController,
      controllerAs: 'ctrl',
      templateUrl: '/app/common/directives/client-selector/client-selector.directive.html',
      link: function (scope, element, attrs, ngModel) {

        ngModel.$render = function () {
          ngModel.$setValidity('required', false)

          ngModel.$setViewValue('test-test')
        }
      }
    }
  }

  ClientSelectorController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    'EntityService'
    // Const
    // Resolved
  ]

  function ClientSelectorController (
    // Angular
    // Libs
    // Managers
    // Services
    EntityService
    // Const
    // Resolved
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        // Public Method
        selectEntity: selectEntity,
        unSelectEntity: unSelectEntity
      })
    }

    function selectEntity () {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual'],
        from: 'sufa'
      }
      EntityService.prompt(config).then(function (entity) {
        self.ngModelCtrl.$setViewValue(entity)
        self.ngModelCtrl.$setValidity('required', true)
      })
    }

    function unSelectEntity () {
      self.ngModelCtrl.$setViewValue(null)
      self.ngModelCtrl.$setValidity('requred', false)
    }

  }
})(window.angular, window._)
